

































import Vue from "vue";

import { DrillProgressStatus } from "../../models/drill";

import IconCorrect from "../../assets/icons/Correct.svg";
import IconIncorrect from "../../assets/icons/Incorrect.svg";
import IconListening from "../../assets/icons/default/Headphone.svg";
import IconPronunciation from "../../assets/icons/default/Microphone.svg";
import IconVocabulary from "../../assets/icons/default/Spelling.svg"; // not the correct one!

// Redundant typing here for the sake of clarity and avoid guessing
// where the numbers come from
interface StatusMapping {
  null: DrillProgressStatus;
  incorrect: DrillProgressStatus;
  correct: DrillProgressStatus;
  listening: DrillProgressStatus;
  pronunciation: DrillProgressStatus;
  vocabulary: DrillProgressStatus;
}

interface Props {
  icons: { [key in DrillProgressStatus]: string };
  mapping: StatusMapping;
  statuses: DrillProgressStatus[];
}

export default Vue.extend<Props>({
  name: "JzDrillProgressBar",
  functional: true,

  props: {
    icons: {
      type: Object as () => { [key in DrillProgressStatus]: string },
      default: () => ({
        0: "",
        1: IconIncorrect,
        2: IconCorrect,
        10: IconListening,
        11: IconPronunciation,
        12: IconVocabulary
      })
    },
    mapping: {
      type: Object as () => StatusMapping,
      default: () => ({
        null: 0,
        incorrect: 1,
        correct: 2,
        listening: 10,
        pronunciation: 11,
        vocabulary: 12
      })
    },
    statuses: { type: Array as () => DrillProgressStatus[], required: true }
  }
});
